import { mapMutations } from 'vuex';
import fpSearchRedirect from 'mixins/composition/search/SearchFunctions';
import config from 'config/appConfig';
import { toAPIDateString, fromAPIDateString, validateDateStringRange } from '@/utils/DateHelper';

const FlatpickrSearchFunctions = {
  data() {
    return {
      fpInputValue: '',
    };
  },
  setup() {
    return {
      fpSearchRedirect,
    };
  },
  computed: {
    startDate() {
      return this.$store.getters.getSearchFilter('startDate') || null;
    },
    endDate() {
      return this.$store.getters.getSearchFilter('endDate') || null;
    },
    fpModelValue: {
      get() {
        if (validateDateStringRange(this.startDate, this.endDate)) {
          return [fromAPIDateString(this.startDate), fromAPIDateString(this.endDate)];
        }
        return '';
      },
      set({ inputValue, dateArr }) {
        this.fpInputValue = inputValue;
        this.$emit('flatpickr-search-input-change', inputValue);
        this.processDateChange(dateArr);
      },
    },
  },
  methods: {
    ...mapMutations({ setSearchFilter: 'SET_SEARCHFILTER' }),
    processDateChange(dateArr) {
      // flatpickr sent a reset
      if (dateArr.length === 0) {
        if (this.onlyFillStore === true) {
          this.setSearchFilter({
            startDate: '',
            endDate: '',
          });
        } else {
          fpSearchRedirect({
            router: this.$router,
            filters: {
              startDate: '',
              endDate: '',
            },
          });
        }
        return;
      }
      const dateFilter = {
        startDate: toAPIDateString(dateArr[0]),
        endDate: toAPIDateString(dateArr[1]),
      };

      // const experiment = this.$store.getters.getExperimentById('experiment_EDVUE-3563');
      // const { variant } = experiment;
      const searchFilter = this.$store.getters.getSearchFilters;

      // set default tolerance if EDVUE-3245 variant 1 and not set earlier
      if (!('tolerance' in searchFilter) && (config.defaults.searchTolerance /* || ['variant1'].includes(variant) */)) {
        // if (['variant1'].includes(variant)) {
        //   dateFilter.tolerance = 3;
        // } else {
        dateFilter.tolerance = config.defaults.searchTolerance;
        // }
      }

      if (this.onlyFillStore === true) {
        this.setSearchFilter(dateFilter);
      } else {
        fpSearchRedirect({
          router: this.$router,
          filters: dateFilter,
        });
      }
    },
  },
};

export default FlatpickrSearchFunctions;
